import { render, staticRenderFns } from "./ShippingSummary.vue?vue&type=template&id=569d64b2&scoped=true"
import script from "./ShippingSummary.vue?vue&type=script&lang=js"
export * from "./ShippingSummary.vue?vue&type=script&lang=js"
import style0 from "./ShippingSummary.vue?vue&type=style&index=0&id=569d64b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "569d64b2",
  null
  
)

export default component.exports